import { useLocation } from '@tanstack/react-router'
import { relatedPagesFor, type RelatedGroup } from '@/lib/related-pages'

function LinkList({ group }: { group: RelatedGroup }) {
  return (
    <>
      <h2 className="mb-4 text-xl font-semibold tracking-tight">{group.heading}</h2>
      <ul className="grid gap-x-6 gap-y-2 text-sm sm:grid-cols-2 lg:grid-cols-4">
        {group.pages.map((page) => (
          <li key={page.href}>
            <a href={page.href} className="text-primary hover:underline">{page.label}</a>
          </li>
        ))}
      </ul>
    </>
  )
}

/**
 * Links to sibling pages and to the articles that explain the page further. A plain link keeps the list
 * crawlable and needs no typed route. The `_site` layout renders it once, at the end of every public page.
 */
export function RelatedPages() {
  const { pathname } = useLocation()
  const related = relatedPagesFor(pathname)
  if (!related) return null
  return (
    <section className="border-t border-border">
      <div className="container mx-auto px-4 py-10">
        <LinkList group={related} />
        {related.more && related.more.pages.length > 0 && (
          <div className="mt-8">
            <LinkList group={related.more} />
          </div>
        )}
      </div>
    </section>
  )
}
